@import '../../../global/style.scss';

:host {
  display: block;
}

.info {
  margin-top: 20px;
  position: relative;
  padding: 20px 20px 20px 55px;
  background-color: #f3f2f2;
  color: #333;
  font-size: 14px;
  line-height: 20px;
}

.info span.info-icon {
  left: 20px;
  top: 20px;
  position: absolute;
  width: 24px;
  height: 24px;
  fill: #9fa0a4;
}

:host(.#{$smallScreenClass}) {
  .info {
    font-size: 12px;
    line-height: 18px;
    padding: 15px 15px 15px 40px;
  }

  .info span.info-icon {
    left: 13px;
    top: 16px;
    font-size: 17px;
    line-height: inherit;
    width: 16px;
    height: 16px;
  }
}
